import { useLocation } from "react-router-dom";
import FooterMicroDisclaimer from "../FooterMicroDisclaimer";

/**
 * Renders FooterMicroDisclaimer on allowed routes only.
 * Works with HashRouter: location.pathname includes the part after #.
 *
 * Excluded patterns:
 * - /admin/*
 * - /contractor/sign-in|sign-up|forgot|reset
 * - /contractors/account, /contractors/billing*
 * - /billing/*
 */
export default function DisclaimerGate() {
  const { pathname } = useLocation();
  const path = (pathname || "/").toLowerCase();

  const excluded = [
    /^\/admin(\/|$)/,
    /^\/contractor\/(sign-in|sign-up|forgot|reset)(\/|$)/,
    /^\/contractors\/(account|billing)(\/|$)/,
    /^\/billing(\/|$)/,
  ];

  const isExcluded = excluded.some((rx) => rx.test(path));
  if (isExcluded) return null;

  return <FooterMicroDisclaimer />;
}
